export const PATHWAY_COMPLETE_REQUEST = "PATHWAY_COMPLETE_REQUEST";
export const PATHWAY_COMPLETE_RECEIVE = "PATHWAY_COMPLETE_RECEIVE";
export const PATHWAY_COMPLETE_FAILURE = "PATHWAY_COMPLETE_FAILURE";
export const RESET_PATHWAY_COMPLETE = "RESET_PATHWAY_COMPLETE";
